<template>
  <v-card class="mb-3">
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 sm4 class="pa-1">
          <div class="caption">Source</div>
          <v-select
            v-model="filters.urlsource"
            outline
            color="primary"
            flat
            single-line
            :items="sourceOptions"
            solo
            hide-details
          ></v-select>
        </v-flex>
        <v-flex xs12 sm4 class="pa-1 default-input">
          <div class="caption">First name</div>

          <v-text-field
            v-model="filters.first_name"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 class="pa-1 default-input">
          <div class="caption">Last name</div>

          <v-text-field
            v-model="filters.last_name"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4 class="pa-1">
          <div class="caption">Interest</div>
          <v-select
            v-model="filters.interest"
            :items="interestOptions"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-select>
        </v-flex>

        <v-flex xs12 sm4 class="pa-1 default-input">
          <div class="caption">Email</div>

          <v-text-field
            v-model="filters.email"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4 class="pa-1 default-input">
          <div class="caption">Phone No.</div>

          <v-text-field
            v-model="filters.phoneno"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4 class="pa-1 default-input">
          <div class="caption">Line ID</div>

          <v-text-field
            v-model="filters.lineid"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="pt-2">
          <v-divider></v-divider>
        </v-flex>

        <v-flex xs12 sm4 class="pa-1">
          <div class="caption">Education Level</div>
          <v-select
            v-model="filters.educationlevel"
            :items="educationlevelOptions"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-select>
        </v-flex>

        <v-flex xs12 sm4 class="pa-1 default-input">
          <div class="caption">Institution</div>

          <v-text-field
            v-model="filters.institution"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4 class="pa-1 default-input">
          <div class="caption">Major</div>

          <v-text-field
            v-model="filters.major"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm2 class="pa-1 default-input">
          <div class="caption">GPA</div>

          <v-text-field
            v-model="filters.gpa"
            outline
            color="primary"
            flat
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <div class="text-xs-right">
        <v-btn color="primary" @click="$emit('onSearch')">Search</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      filters: null,
      sourceOptions: [
        {
          value: null,
          text: 'All'
        },
        {
          value: 'diyresume',
          text: 'DIY Resume'
        },
        {
          value: 'event',
          text: 'Event'
        }
      ],
      interestOptions: [
        {
          value: null,
          text: 'All'
        },
        {
          value: 'ฝึกงาน',
          text: 'Intern'
        },
        {
          value: 'สมัครงาน',
          text: 'Apply'
        }
      ],
      educationlevelOptions: [
        {
          value: null,
          text: 'All'
        },
        {
          value: 'first-year / ระดับชั้นปีที่ 1',
          text: 'first-year / ระดับชั้นปีที่ 1'
        },
        {
          value: 'second-year / ระดับชั้นปีที่ 2',
          text: 'second-year / ระดับชั้นปีที่ 2'
        },
        {
          value: 'third-year / ระดับชั้นปีที่ 3',
          text: 'third-year / ระดับชั้นปีที่ 3'
        },
        {
          value: 'fourth-year / ระดับชั้นปีที่ 4',
          text: 'fourth-year / ระดับชั้นปีที่ 4'
        },
        {
          value: 'fifth-year / ระดับชั้นปีที่ 5',
          text: 'fifth-year / ระดับชั้นปีที่ 5'
        },
        {
          value: 'Graduated / จบการศึกษาแล้ว',
          text: 'Graduated / จบการศึกษาแล้ว'
        }
      ]
    }
  },
  mounted() {
    this.filters = this.value
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/scgcareer/FilterApplicant.vue